import React, { useContext, useMemo, useState } from "react";
import { Box } from "@mui/material";
// @ts-ignore
import { StriimMessageBox } from "@striim/striim-ui-v2";
import { SelectPdbContainer } from "src/modules/flow-designer/vts/select-tables-modal/components/select-pdb/select-pdb";
// @ts-ignore
import oracleProvider from "app/components/appwizard/component-wizards/wizards/source/database-reader/configs/providers/oracle.js";
// @ts-ignore
import ojetProvider from "app/components/appwizard/component-wizards/wizards/source/database-reader/configs/providers/ojet.js";
import { wizardcontext } from "../../../source-configurator-tool";
import { StepProps } from "../../source-configurator.types";
import SidebarStepFooter from "../../sidebar-step-footer";

const SelectPdbStepPage = ({ onNext, onBack, onCancel }: StepProps) => {
    const { sourceType, connectionParams, pdbList, selectedPdb, setState } = useContext(wizardcontext);
    const [error, setError] = useState<string | null>(null);

    const formValues = useMemo(() => {
        if (connectionParams?.useConnectionProfile !== false) {
            return connectionParams;
        }
        const provider = sourceType === "OJET" ? ojetProvider : oracleProvider;
        const connectionUrl = provider.getJDBCURL({ get: (key: string) => connectionParams?.[key] });
        return { ...connectionParams, connectionUrl };
    }, [connectionParams, sourceType]);

    const handleSelectPdb = (pdb: string) => {
        setState((prev: any) => ({
            ...prev,
            selectedPdb: pdb,
            connectionParams: { ...prev.connectionParams, containerName: pdb, isPDB: true }
        }));
    };

    const handlePdbCheckComplete = (isPdb: boolean, pdbs: string[]) => {
        if (isPdb && pdbs.length > 0) {
            setState((prev: any) => ({ ...prev, isPdb: true, pdbList: pdbs }));
        } else {
            setState((prev: any) => ({
                ...prev,
                isPdb: false,
                pdbList: [],
                selectedPdb: null,
                connectionParams: { ...prev.connectionParams, containerName: undefined, isPDB: false }
            }));
            onNext();
        }
    };

    if (error) {
        return (
            <Box sx={{ width: "100%" }}>
                <StriimMessageBox type="ERROR" text={error} customCardStyles={{ width: "100%" }} />
                <SidebarStepFooter onCancel={onCancel} onBack={onBack} showNext={false} />
            </Box>
        );
    }

    return (
        <Box sx={{ width: "100%" }}>
            <SelectPdbContainer
                formValues={formValues}
                dbType={sourceType ?? ""}
                metaObjectId={connectionParams.objectID ?? undefined}
                adapterName={connectionParams.sourceAdapter ?? ""}
                selectedPdb={selectedPdb ?? null}
                cachedPdbList={pdbList ?? []}
                onSelectPdb={handleSelectPdb}
                onPdbCheckComplete={handlePdbCheckComplete}
                onError={setError}
            />
            <SidebarStepFooter onCancel={onCancel} onBack={onBack} onNext={onNext} nextDisabled={!selectedPdb} />
        </Box>
    );
};

export default SelectPdbStepPage;
